<template>
  <Modal ref="modal" title="Rejeitadas" @cancel="close">
    <form class="export-container" @submit.prevent="handleSubmit">
      <Period legend="Insira o período" :firstModelValue="initialDate" :secondModelValue="finalDate"
        @update:firstModelValue="$event => (this.initialDate = $event)"
        @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" />

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Period from 'core/Period'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'TeoricasRejeitadasModal',
  components: {
    Modal,
    Period,
    Button,
    TrayArrowDown,
  },
  data() {
    return {
      initialDate: '',
      finalDate: '',
      loading: false,
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()

      this.initialDate = ''
      this.finalDate = ''
      this.loading = false
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const params = {
        dataInicial: this.initialDate,
        dataFinal: this.finalDate,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/export/planilha/aulas/teoricas/pendentes`, {
        params,
      })
        .then((res) => {
          _export.downloadCSV(res.body.dados, 'teoricas-rejeitadas')
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if (!this.initialDate || !this.finalDate) {
        this.$toasted.show('Os campos de período são obrigatórios.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      const initial = new Date(this.initialDate)
      const final = new Date(this.finalDate)

      if (final < initial) {
        this.$toasted.show('A data final deve ser menor que a data inicial!', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      return true
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 40vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>